import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { VisaFormApi } from "../../../api/visa-form/visa-form.api";
import { VisaTypeApi } from "../../../api/visa-type/visa-type.api";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { VisaRequestFrontApi } from "../../../api/visa-request-front/visa-request-front.api";
import { dateToView } from "../../../utils/date.utils";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus, STATUS_VISA } from "../manage-request/enum/request-form.enum";
import { RootState } from "../../../store/store";
import { checkPermission, permission_config } from "../../../utils/app.utils";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
//    const profile = useSelector((state: RootState) => state.profile.profile) as any;
//     const permission: any[] = profile?.permission || [];
//     const checkPermit: permission_config = checkPermission(`VISA_INTENDANT`, permission)
    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");

    const [data, setData] = useState<any[]>([]);
    const [visaType, setVisaType] = useState<any[]>([]);


    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 120, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 600, align: "left", label: t("ประเภทคำร้อง")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 250, label: t("วันที่ส่ง")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("สถานะ")
        },


        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 150, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            visa_form_name,
            status_visa,
            sent_date,
            id_visa_request,
            id_visa_form
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: visa_form_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: sent_date ? dateToView(sent_date) : "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(status_visa)}
                        type={renderStatus(status_visa)}
                    />,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.request_form.manage_request_form_detail.replace(':id', id_visa_form))}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit={[STATUS_VISA.DRAFT, STATUS_VISA.WAITING_PAYMENT, STATUS_VISA.REVIEW].includes(status_visa)}
                            enableView
                            enableDelete={status_visa === STATUS_VISA.DRAFT}
                            onViewClick={() => navigate(routeName.request_form.visa_request_view.replace(':id', id_visa_request))}
                            onEditClick={() => navigate(routeName.request_form.visa_request_detail.replace(':id', id_visa_request))}
                            onDeleteClick={() => handleDeleteList(id_visa_request)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_visa_request: number) => {
        alertActive(t("ฟอร์มคำร้อง"), t("ต้องการลบฟอร์มคำร้อง ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await VisaRequestFrontApi.delete(id_visa_request).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ฟอร์มคำร้อง"), t("ฟอร์มคำร้อง เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ฟอร์มคำร้อง"), t("ฟอร์มคำร้อง ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (status !=='ALL') query = { ...query, status_visa : status }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }

        dispatch(setLoading());
        await VisaRequestFrontApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])



    useEffect(() => {
        handleGetData()
    }, [handleGetData])


    const getVisaType = async () => {
        const param = {
            page: 1,
            limit: 100
        }
        await VisaTypeApi.list(param).then((res) => {
            if (res.status < 300) {
                setVisaType(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getVisaType()
    }, [])
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        visaType,
        status,
        set_status
    }
}

export default ManageState